import { common } from '@tencent/ceiba-base-components';
import Vue from 'vue';

let loginManagerInstance = null;

const isApp = () => !!window.navigator.userAgent.match(/tgclub/i);
const isSafari = () => /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

const checkAccountType = () => (common.tool.getCookie('acctype') === 'wx' ? 'wx' : 'qc');

const SAFARI_WX_APPID = 'wx5f930f997198dbd6';// safari下微信用游戏家公会

function loginByQQ(loginManager) {
  if (Vue.prototype.$miloLoginManager) {
    loginManager.mobileLoginByQQConnect({
      appId: '101478665',
      redirectUri: 'https://xinyue.qq.com/comm-htdocs/login/qc_redirect.html',
      sUrl: location.href,
    });
  } else {
    loginManager.login({
      iUseQQConnect: 1, // 是否使用QQ互联
      oQQConnectParams: {
        appId: '101478665',
        redirect_uri: 'http://xinyue.qq.com/comm-htdocs/login/qc_redirect.html',
      },
    });
  }
  localStorage.curPlatform = 'qq';
}

function loginByWx(loginManager) {
  if (isSafari()) {
    const urlTmp = window.location.href.split('?')[0];
    // alert(urlTmp);
    window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${SAFARI_WX_APPID}&redirect_uri=${encodeURIComponent(urlTmp)}&response_type=code&scope=snsapi_userinfo#wechat_redirect`;
  } else {
    if (Vue.prototype.$miloLoginManager) {
      loginManager.mobileLoginByWX({
        appId: isSafari() ? SAFARI_WX_APPID : 'wx5a3bbeac0d87c75a', // safari用游戏家公会,其他默认用心悦公众号
        scope: 'snsapi_userinfo', // 默认是 snsapi_base 静默授权，如果游戏无静默权限，就需要手动改成 snsapi_userinfo
        userinfoSpan: 'userinfo',
        forcePopup: true,
        snapShotTips: true,
        snapShotCustomTips: '我同意“本活动获取您的个人信息，仅用于该活动的查询、抽奖、领取、发货、签到等操作”',
      });
    } else {
      loginManager.loginByWX({
        appConfig: {
          avoidConflict: '', // 这里建议为空字符串，这样只会在微信客户端中做防串号
          QQBrowserAppId: '106', // 在QQ浏览器端申请的APPID，保持不变
          WxAppId: isSafari() ? SAFARI_WX_APPID : 'wx5a3bbeac0d87c75a', // safari用游戏家公会,其他默认用心悦公众号
          AppName: '心悦俱乐部', // 业务的中文名称
          scope: 'snsapi_userinfo', // 默认是 snsapi_base 静默授权，如果游戏无静默权限，就需要手动改成 snsapi_userinfo
          LogoUrl: 'http://ossweb-img.qq.com/images/feiji/web201507/logo.png', // 业务在授权时需要显示的正方形标准Logo，
        },
        userinfoSpan: 'userinfo',
        forcePopup: true,
        snapShotTips: true,
        snapShotCustomTips: '我同意“本活动获取您的个人信息，仅用于该活动的查询、抽奖、领取、发货、签到等操作”',
      });
    }
  }
  localStorage.curPlatform = 'wx';
}
export default {
  /**
   * 心悦登录特点
   * 游戏：只有手游，没有端游
   * 注销：APP里没有登出操作
   * 自动登录:QQ浏览器pt登录，微信则wx登录
   * 心悦APP内QQ默认用QC互联登录
   */
  initLogin: async () => new Promise((resolve) => {
    window.ams_login_avoid_conflict = true;
    console.log('tgclub initLogin begin');
    // 为了兼容qq客户端内打开,需要手动清除pt登录的cookie
    document.cookie = `uin=;expires=${new Date(Date.now() - 1)}`;
    document.cookie = `skey=;expires=${new Date(Date.now() - 1)}`;
    // window.iUseQQConnect = common.tool.getCookie('acctype') === 'qc' ? 1 : 0;
    // 因为midas只支持qc登录态,所以心悦先强制qc.
    window.iUseQQConnect = 1;
    // 兼容 milo 调用方式
    if (Vue.prototype.$miloLoginManager) {
      loginManagerInstance = new Vue.prototype.$miloLoginManager({
        commonParams: {
          iUseQQConnect: window.iUseQQConnect,
          useAppLogin: ['tgclub'],
        },
        mobileParams: {
          oWXParams: {
            gameDomain: 'xinyue.qq.com',
            appId: isSafari() ? SAFARI_WX_APPID : 'wx5a3bbeac0d87c75a',
            scope: 'snsapi_userinfo',
          },
          oQQConnectParams: {
            appId: '101478665',
            redirectUri: 'https://xinyue.qq.com/comm-htdocs/login/qc_redirect.html',
            sUrl: location.href,
          },
        },
      });
      console.log('tgclub initLogin done instance=', loginManagerInstance);
      resolve();
    } else {
      // todo 以上稳定后删除此逻辑
      // 过渡期兼容旧的cdn版本
      window.need('biz.login', (LoginManager) => {
        LoginManager.init({
          appConfig: {
            avoidConflict: '', // 这里建议为空字符串，这样只会在微信客户端中做防串号
            gameDomain: 'xinyue.qq.com',
            WxAppId: isSafari() ? SAFARI_WX_APPID : 'wx5a3bbeac0d87c75a',
            scope: 'snsapi_userinfo',
          },
          oQQConnectParams: {
            appId: '101478665',
            redirect_uri: 'https://xinyue.qq.com/comm-htdocs/login/qc_redirect.html',
          },
          iUseQQConnect: window.iUseQQConnect,
        });
        loginManagerInstance = LoginManager;
        console.log('tgclub initLogin done instance=', loginManagerInstance);
        resolve();
      });
    }
  }),
  /**
   * 去登录操作
   * @param {登录方式} loginType
   */
  login: async (params = { loginType: 'qq' }) => {
    console.log('tgclub login');
    if (params.loginType === 'qq') loginByQQ(loginManagerInstance);
    if (params.loginType === 'wx') loginByWx(loginManagerInstance);
  },
  /**
   * 检查登录信息，返回是否登录+登录信息
   * @returns {
   *  "isLogin":true,
   *  "userInfo":{}
   * }
   */
  checkLogin: async () => await new Promise((resolve) => {
    console.log('loginManagerInstance', loginManagerInstance);
    if (isSafari()) {
      // safari浏览器下,checkLogin之前去掉登录态参数
      // url中存在appid的参数并且不为游戏家公会的appid
      const hasLoginParams = (location.href.indexOf(SAFARI_WX_APPID) < 0)
        && (location.href.indexOf('appid=') > 0);
      // 有appid的cookie但是不为游戏家公会的cookie,同时acctype为wx
      // const isLoginCookieAppidSafari = common.tool.getCookie('appid') !== null
      //   && common.tool.getCookie('appid') !== SAFARI_WX_APPID
      //   && common.tool.getCookie('acctype') === 'wx';
      // if (isLoginCookieAppidSafari) {
      //   clearLoginCookie();
      // }
      if (hasLoginParams) {
        let newHref = location.href;
        newHref = common.tool.setUrlParam('appid', '', newHref);
        newHref = common.tool.setUrlParam('code', '', newHref);
        newHref = common.tool.setUrlParam('acctype', '', newHref);
        newHref = common.tool.setUrlParam('state', '', newHref);
        location.href = newHref;
      }
    }
    if (isSafari() && !common.platform.isWX) {
      // safari浏览器中
      const wxcode = common.tool.getQueryparams('code');
      if (wxcode) {
        // 存在wxcode,优先校验微信登录
        console.error('checkRealLogin wxcode:', wxcode);
        loginManagerInstance.wxCodeToOpenid({
          code: wxcode,
          appid: SAFARI_WX_APPID, // safari下必定用游戏家公会的appid
          sServiceType: 'tgclub',
        }, () => {
          loginManagerInstance.checkLogin().then((res) => {
            const { userInfo } = res;
            console.log('wxcode checkLogin', userInfo);
            let newHref = location.href;
            newHref = common.tool.setUrlParam('code', '', newHref);
            newHref = common.tool.setUrlParam('state', '', newHref);
            location.href = newHref;
            // window.location.reload();
          })
            .catch((err) => {
              console.error('wxcode checkLogin Failed Code:', err.errCode);
              console.error('wxcode checkLogin Failed info:', err.errInfo);
              alert('登录态已过期，请重新登录后再试');
            });
        });
        return;
      }
    }
    if (Vue.prototype.$miloLoginManager) {
      loginManagerInstance.checkRealLogin().then((res) => {
        const { isLogin, userInfo } = res;
        if (userInfo) {
          userInfo.avatar = userInfo?.avatarUrl ?? userInfo?.formatUserInfo?.avatarUrl;
        }
        console.log('checkRealLogin  with $miloLoginManager userInfo =', userInfo);
        // 采用localStorage 保持登录的连续性 保持活动页面上一次保持登录的方式
        //
        let { curPlatform } = localStorage;
        console.log('checkRealLogin curPlatform from localStorage ', curPlatform);
        if (!curPlatform) {
          curPlatform = Vue.prototype.$platform.isWX ? 'wx' : 'qq';
        }
        if (isApp()) {
          curPlatform = checkAccountType();
        }
        console.log('checkRealLogin curPlatform ', curPlatform);
        resolve({
          isLogin,
          userInfo,
        });
      })
        .catch((err) => {
          console.error('checkRealLogin Failed Code:', err.errCode);
          console.error('checkRealLogin Failed info:', err.errInfo);
          clearLoginCookie();
          resolve({
            isLogin: false,
            userInfo: {},
          });
        });
    } else {
      // todo 以上稳定后删除此逻辑
      // 过渡期兼容旧的cdn版本
      loginManagerInstance.checkRealLogin((userInfo) => {
        console.log('checkRealLogin', userInfo);
        // 采用localStorage 保持登录的连续性 保持活动页面上一次保持登录的方式
        //
        let { curPlatform } = localStorage;
        console.log('checkRealLogin curPlatform from localStorage ', curPlatform);
        if (!curPlatform) {
          curPlatform = Vue.prototype.$platform.isWX ? 'wx' : 'qq';
        }
        if (isApp()) {
          curPlatform = checkAccountType();
        }
        console.log('checkRealLogin curPlatform ', curPlatform);
        if (common.tool.cookie.get('acctype') === 'qc') {
          // qc 登录,获取qq信息
          let uin = common.tool.getCookie('uin') || '';
          uin = uin.substr(1);
          if (uin.indexOf('0') === 0) {
            uin = uin.substr(1);
          }
          // QQ号不显示 昵称 因为有会有表情文字其是乱码
          // eslint-disable-next-line no-param-reassign
          userInfo.nickName = uin || userInfo.nickname;
          loginManagerInstance.getUserFace((sAvatar) => {
            console.log(' get QQ getUserFace sAvatar ', sAvatar);
            // eslint-disable-next-line no-param-reassign
            userInfo.avatar = typeof sAvatar === 'string' ? sAvatar : sAvatar.userFace;
            console.log(' get QQ Userinfo ', userInfo);
            resolve({
              isLogin: true,
              userInfo,
            });
          });
        } else {
          // 微信登录
          const getUserInfoParam = {
            openid: common.tool.getCookie('openid'),
            access_token: common.tool.getCookie('access_token'),
            lang: 'zh_CN',
          };
          console.log('getUserInfoByWxOpenId=', getUserInfoParam);
          loginManagerInstance.getUserInfoByWxOpenId(getUserInfoParam, (wxUserInfo) => {
            console.log('登录成功，wx用户信息为', wxUserInfo);
            // eslint-disable-next-line no-param-reassign
            userInfo.avatar = wxUserInfo.headimgurl ? `${wxUserInfo.headimgurl}/64` : '';
            // eslint-disable-next-line no-param-reassign
            userInfo.nickName = wxUserInfo.nickname;
            resolve({
              isLogin: true,
              userInfo,
            });
          }, (err) => {
            console.log('获取用户信息失败', err);
          });
        }
      }, (error) => {
        console.error('checkRealLogin Failed:', error);
        clearLoginCookie();
        resolve({
          isLogin: false,
          userInfo: {},
        });
      });
    }
  }),
  /**
   * 登出操作
   */
  logout: async () => {
    await loginManagerInstance.logout({});
    localStorage.curPlatform = '';
  },

};
function clearLoginCookie() {
  const loginCookies = ['acctype', 'openid', 'skey', 'uin', 'appid', 'access_token'];
  const keys = document.cookie?.match(/[^ =;]+(?==)/g)?.filter(key => loginCookies.includes(key)) || [];
  if (keys.length === 0) return;
  const keysFormat = Array.from(new Set(keys));
  const host = location.hostname.split('.');
  const domainList = [];
  for (let i = 0; i < host.length - 1; i++) {
    domainList.push(host.slice(i - host.length).join('.'));
  }
  keysFormat.forEach(key => domainList.forEach(domain => clearCookie(key, domain)));
}
/**
 * @description 清除cookie
 * @param {String} key key
 * @param {String} domain cookie域
 * @returns
 */
function clearCookie(key, domain = location.hostname, path = '/') {
  document.cookie = `${key}=;expires=${new Date(0).toUTCString()};domain=${domain};path=${path}`;
}
